import React from "react";

type Props = { className?: string; size?: number };

const ShopifyLogo: React.FC<Props> = ({ className, size = 40 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 40 40"
    role="img"
    aria-label="Shopify"
    className={className}
  >
    <rect x={2} y={2} width={36} height={36} rx={10} fill="#95BF47" />
    <path
      d="M14 26c1.2 1.4 3.1 2.4 5.7 2.4 3.1 0 5.3-1.7 5.3-4.3 0-2.1-1.4-3.3-4.1-4l-1.3-.3c-1.7-.4-2.4-.9-2.4-1.9 0-1.1 1-1.9 2.4-1.9 1.4 0 2.4.6 3.2 1.5l1.6-1.8C23.3 14 22 13.2 20.1 13c-3 0-5.1 1.8-5.1 4.3 0 2.1 1.3 3.3 3.9 4l1.4.3c1.8.4 2.6.9 2.6 2 0 1.1-1.1 1.9-2.7 1.9-1.7 0-3-.7-4-1.9L14 26z"
      fill="#FFFFFF"
    />
  </svg>
);

export default ShopifyLogo;
